












import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {LatLon} from "../../n-maps/models/LatLon";
import {equals} from "../../utils";
import NMapPolygon from "../../n-maps/NMapPolygon.vue"
import schemaHelper from "../../kepler_sdk/schemaHelper";

@Component({
  components: {NMapPolygon},
})
export default class Poly extends Vue {
  // Value passed by v-model
  @Prop() public readonly value: any

  @Prop({default: ''}) public readonly placeholder!: string
  @Prop({default: ''}) public readonly label!: string

  public polyMarker: LatLon[][] = []
  public centerMap: LatLon = this.getBarycenter()


  @Watch('value')
  public valueChanged(newValue: any[][], oldValue: any) {

    console.log(this.value)
    this.polyMarker = []
  if(!newValue) {
      this.polyMarker . push( [new LatLon(39,9)])
    this.centerMap = this.getBarycenter()
    return
  }
    if (!equals(newValue, oldValue)) {
      newValue.forEach(a=>{
        const latLons: LatLon[] = []
        a.forEach(p=>{
          latLons.push(new LatLon(p.lat,p.lng))
        })
        this.polyMarker . push(latLons)
      })

      this.centerMap = this.getBarycenter()
    }
  }

  mounted() {

        this.valueChanged(this.value, null)



  }

  public creckers(e: LatLon[]) {
    console.log(e, this)
    this.polyMarker = [e]
    this.$emit('input', e)
  }
  private getBarycenter() :LatLon {
    let x = 0
    let y = 0
    let xx = 0
    let yy = 0

    if(this.polyMarker && this.polyMarker.length > 0) {

        this.polyMarker.forEach( a => {
          x = 0
          y = 0

          a.forEach(p =>{
              x += p.latitude
              y += p.longitude

            })

          x = x / a.length
          y = y / a.length
          xx += x
          yy += y
        })
        xx = xx / this.polyMarker.length
        yy = yy / this.polyMarker.length
    }
    return new LatLon(xx,yy)
  }
}
